<script lang="ts">
import { type Snippet } from 'svelte'
import { fade } from 'svelte/transition'

type Props = {
	delay?: number
	children?: Snippet
}

let { delay, children }: Props = $props()
</script>

<span in:fade={{ delay }}>{@render children?.()}</span>
